import * as types from './displaysActionTypes';
import { DisplaysActionKeys as keys } from './displaysActionKeys';
import { IDisplayConfig } from './displaysInterfaces';
export const displaysActionCreators = {
  deleteDisplayConfig: (payload: IDisplayConfig): types.DeleteDisplayConfig => ({
    payload,
    type: keys.DELELTE_DISPLAY_CONFIG
  }),
  fetchDisplayConfigs: (): types.FetchDisplayConfigs => ({ type: keys.FETCH_DISPLAY_CONFIGS }),
  removeDisplayConfg: (userSid: string): types.RemoveDisplayConfig => ({
    payload: { userSid },
    type: keys.REMOVE_DISPLAY_CONFIG
  }),
  setDisplayConfigs: (payload: IDisplayConfig[]): types.SetDisplayConfigs => ({
    payload,
    type: keys.SET_DISPLAY_CONFIGS
  }),
  updateDisplayConfig: (payload: IDisplayConfig): types.UpdateDisplayConfig => ({
    payload,
    type: keys.UPDATE_DISPLAY_CONFIG
  })
};
